import { ActivityLogTab } from "@features/mx/shared/components/ActivityLog";
import { InfoCard } from "./InfoCard";
import { QuickActions } from "./QuickActions";
import { Tabs } from "@shared/ui/tabs";
import { RoutesTab } from "./tabs/Routes";
import { MeterReadingsTab } from "./tabs/MeterReadings";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import {
  useGetMeterReaderAssignedRoutes,
  useGetMeterReaderDetail,
  useGetMeterReaderReadings,
} from "@features/mx/settings/hooks";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const Landing = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("view");
  const navigate = useNavigate();
  const remoteUtilityId = getRemoteUtilityId();
  const { data } = useGetMeterReaderDetail(remoteUtilityId, id);

  const { data: meterReadings } = useGetMeterReaderReadings(
    remoteUtilityId,
    id,
  );
  const tabComponents = {
    routes: {
      label: "Routes",
      shortLabel: "routes",
      component: <RoutesTab />,
    },
    meterReadings: {
      label: "Meter Readings",
      shortLabel: "meter-readings",
      component: <MeterReadingsTab meterReadings={meterReadings} />,
    },
    logs: {
      label: "Activity Log",
      shortLabel: "logs",
      component: <ActivityLogTab entityId={id} entityType={"meter_reader"} />,
    },
  };

  return (
    <div>
      <div className="flex items-center gap-4 mb-2">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full hover:bg-gray-100"

          onClick={() => navigate("/mx/manage/field-technician")}
        >
          <ArrowLeft className="h-5 w-5 text-gray-700" />
        </Button>
        <div>
          <h1 className="text-xl font-semibold text-gray-900">
            Meter Reader Details
          </h1>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 lg:col-span-9">
          <InfoCard data={data} />
        </div>
        <div className="col-span-12 lg:col-span-3">
          <QuickActions data={data} />
        </div>
      </div>
      <div className="pt-4">
        <Tabs
          defaultValue="routes"
          tabComponents={tabComponents}
          tabsListFullWidth={true}
          tabsListClassName="grid grid-cols-3"
          disableUrlSync={true}
        />
      </div>
    </div>
  );
};
